import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'components/legacy/Card';
import { LinkFarm } from 'components/core/LinkFarm';
import { H2 } from 'components/core/Typography';

export default function ContentLinks({ columns, links, title }) {
	return (
		<Card className="content-links">
			<div className="card-content">
				<H2 className="card-title">{title}</H2>
				<LinkFarm
					links={links}
					columns={columns}
				/>
			</div>
		</Card>
	);
}

ContentLinks.propTypes = {
	columns: PropTypes.number,
	links: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			uri: PropTypes.string.isRequired,
		}),
	).isRequired,
	title: PropTypes.string.isRequired,
};
